import { MatPaginatorIntl } from '@angular/material';
import { Injectable } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Injectable()
export class MatPaginatorIntlRu extends MatPaginatorIntl {

  itemsPerPageLabel = this.i18n('Элементов на странице');
  nextPageLabel = this.i18n('Следующая страница');
  previousPageLabel = this.i18n('Предыдущая страница');
  firstPageLabel = this.i18n('Первая страница');
  lastPageLabel = this.i18n('Последняя страница');

  constructor (private i18n: I18n) {
    super();
  }

  getRangeLabel = function (page, pageSize, length) {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.i18n('из')} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${this.i18n('из')} ${length}`;
  };

}
